module.exports = __webpack_public_path__ + "static/media/viatris.153010a6.png";